/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { externalCredentialsCreateAwsIam } from "../funcs/externalCredentialsCreateAwsIam.js";
import { externalCredentialsCreateGcpIam } from "../funcs/externalCredentialsCreateGcpIam.js";
import { externalCredentialsDeleteAwsIam } from "../funcs/externalCredentialsDeleteAwsIam.js";
import { externalCredentialsDeleteGcpIam } from "../funcs/externalCredentialsDeleteGcpIam.js";
import { externalCredentialsGetAwsIam } from "../funcs/externalCredentialsGetAwsIam.js";
import { externalCredentialsGetGcpIam } from "../funcs/externalCredentialsGetGcpIam.js";
import { externalCredentialsGetGcpSetupInfo } from "../funcs/externalCredentialsGetGcpSetupInfo.js";
import { externalCredentialsList } from "../funcs/externalCredentialsList.js";
import { externalCredentialsListAwsIam } from "../funcs/externalCredentialsListAwsIam.js";
import { externalCredentialsListGcpIam } from "../funcs/externalCredentialsListGcpIam.js";
import { externalCredentialsUpdateAwsIam } from "../funcs/externalCredentialsUpdateAwsIam.js";
import { externalCredentialsUpdateGcpIam } from "../funcs/externalCredentialsUpdateGcpIam.js";
import { externalCredentialsVerifyGcpIam } from "../funcs/externalCredentialsVerifyGcpIam.js";
import { ClientSDK, RequestOptions } from "../lib/sdks.js";
import { AwsIamCredential } from "../models/components/awsiamcredential.js";
import { GcpIamCredential } from "../models/components/gcpiamcredential.js";
import { GcpSetupInfo } from "../models/components/gcpsetupinfo.js";
import { ListExternalCredentialsResult } from "../models/components/listexternalcredentialsresult.js";
import { VerifyCredentialResult } from "../models/components/verifycredentialresult.js";
import {
  CreateAwsIamCredentialRequest,
  CreateAwsIamCredentialSecurity,
} from "../models/operations/createawsiamcredential.js";
import {
  CreateGcpIamCredentialRequest,
  CreateGcpIamCredentialSecurity,
} from "../models/operations/creategcpiamcredential.js";
import {
  DeleteAwsIamCredentialRequest,
  DeleteAwsIamCredentialSecurity,
} from "../models/operations/deleteawsiamcredential.js";
import {
  DeleteGcpIamCredentialRequest,
  DeleteGcpIamCredentialSecurity,
} from "../models/operations/deletegcpiamcredential.js";
import {
  GetAwsIamCredentialRequest,
  GetAwsIamCredentialSecurity,
} from "../models/operations/getawsiamcredential.js";
import {
  GetGcpIamCredentialRequest,
  GetGcpIamCredentialSecurity,
} from "../models/operations/getgcpiamcredential.js";
import {
  GetGcpSetupInfoRequest,
  GetGcpSetupInfoSecurity,
} from "../models/operations/getgcpsetupinfo.js";
import {
  ListAwsIamCredentialsRequest,
  ListAwsIamCredentialsSecurity,
} from "../models/operations/listawsiamcredentials.js";
import {
  ListExternalCredentialsRequest,
  ListExternalCredentialsSecurity,
} from "../models/operations/listexternalcredentials.js";
import {
  ListGcpIamCredentialsRequest,
  ListGcpIamCredentialsSecurity,
} from "../models/operations/listgcpiamcredentials.js";
import {
  UpdateAwsIamCredentialRequest,
  UpdateAwsIamCredentialSecurity,
} from "../models/operations/updateawsiamcredential.js";
import {
  UpdateGcpIamCredentialRequest,
  UpdateGcpIamCredentialSecurity,
} from "../models/operations/updategcpiamcredential.js";
import {
  VerifyGcpIamCredentialRequest,
  VerifyGcpIamCredentialSecurity,
} from "../models/operations/verifygcpiamcredential.js";
import { unwrapAsync } from "../types/fp.js";

export class ExternalCredentials extends ClientSDK {
  /**
   * createAwsIamCredential externalCredentials
   *
   * @remarks
   * Create an AWS IAM external credential. Requires org:admin.
   */
  async createAwsIam(
    request: CreateAwsIamCredentialRequest,
    security?: CreateAwsIamCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<AwsIamCredential> {
    return unwrapAsync(externalCredentialsCreateAwsIam(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * createGcpIamCredential externalCredentials
   *
   * @remarks
   * Create a GCP IAM external credential. Requires org:admin.
   */
  async createGcpIam(
    request: CreateGcpIamCredentialRequest,
    security?: CreateGcpIamCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GcpIamCredential> {
    return unwrapAsync(externalCredentialsCreateGcpIam(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteAwsIamCredential externalCredentials
   *
   * @remarks
   * Soft-delete an AWS IAM external credential by ID. Requires org:admin. Refused with a conflict while any live external key still names the credential, since deleting it would leave those keys unable to reach the key material they sign with.
   */
  async deleteAwsIam(
    request: DeleteAwsIamCredentialRequest,
    security?: DeleteAwsIamCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(externalCredentialsDeleteAwsIam(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * deleteGcpIamCredential externalCredentials
   *
   * @remarks
   * Soft-delete a GCP IAM external credential by ID. Requires org:admin. Refused with a conflict while any live external key still names the credential, since deleting it would leave those keys unable to reach the key material they sign with.
   */
  async deleteGcpIam(
    request: DeleteGcpIamCredentialRequest,
    security?: DeleteGcpIamCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<void> {
    return unwrapAsync(externalCredentialsDeleteGcpIam(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getAwsIamCredential externalCredentials
   *
   * @remarks
   * Get an AWS IAM external credential by ID. Requires org:read.
   */
  async getAwsIam(
    request: GetAwsIamCredentialRequest,
    security?: GetAwsIamCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<AwsIamCredential> {
    return unwrapAsync(externalCredentialsGetAwsIam(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getGcpIamCredential externalCredentials
   *
   * @remarks
   * Get a GCP IAM external credential by ID. Requires org:read.
   */
  async getGcpIam(
    request: GetGcpIamCredentialRequest,
    security?: GetGcpIamCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GcpIamCredential> {
    return unwrapAsync(externalCredentialsGetGcpIam(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * getGcpSetupInfo externalCredentials
   *
   * @remarks
   * Report what the customer must grant in their own GCP project before Speakeasy can impersonate a service account there. Readable before any credential exists, since impersonation is a precondition of creating one. Requires org:read.
   */
  async getGcpSetupInfo(
    request?: GetGcpSetupInfoRequest | undefined,
    security?: GetGcpSetupInfoSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GcpSetupInfo> {
    return unwrapAsync(externalCredentialsGetGcpSetupInfo(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listExternalCredentials externalCredentials
   *
   * @remarks
   * List the organization's external credentials (provider-independent summary). Optionally filter by provider. Requires org:read.
   */
  async list(
    request?: ListExternalCredentialsRequest | undefined,
    security?: ListExternalCredentialsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListExternalCredentialsResult> {
    return unwrapAsync(externalCredentialsList(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listAwsIamCredentials externalCredentials
   *
   * @remarks
   * List the organization's AWS IAM external credentials. Requires org:read.
   */
  async listAwsIam(
    request?: ListAwsIamCredentialsRequest | undefined,
    security?: ListAwsIamCredentialsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListExternalCredentialsResult> {
    return unwrapAsync(externalCredentialsListAwsIam(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * listGcpIamCredentials externalCredentials
   *
   * @remarks
   * List the organization's GCP IAM external credentials. Requires org:read.
   */
  async listGcpIam(
    request?: ListGcpIamCredentialsRequest | undefined,
    security?: ListGcpIamCredentialsSecurity | undefined,
    options?: RequestOptions,
  ): Promise<ListExternalCredentialsResult> {
    return unwrapAsync(externalCredentialsListGcpIam(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateAwsIamCredential externalCredentials
   *
   * @remarks
   * Replace an AWS IAM external credential's configuration. Requires org:admin.
   */
  async updateAwsIam(
    request: UpdateAwsIamCredentialRequest,
    security?: UpdateAwsIamCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<AwsIamCredential> {
    return unwrapAsync(externalCredentialsUpdateAwsIam(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * updateGcpIamCredential externalCredentials
   *
   * @remarks
   * Replace a GCP IAM external credential's configuration. Requires org:admin.
   */
  async updateGcpIam(
    request: UpdateGcpIamCredentialRequest,
    security?: UpdateGcpIamCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<GcpIamCredential> {
    return unwrapAsync(externalCredentialsUpdateGcpIam(
      this,
      request,
      security,
      options,
    ));
  }

  /**
   * verifyGcpIamCredential externalCredentials
   *
   * @remarks
   * Probe that Speakeasy can impersonate the service account a GCP IAM credential names, and report the principal it resolves to. Ephemeral: nothing is persisted. Rate limited per organization. Requires org:admin.
   */
  async verifyGcpIam(
    request: VerifyGcpIamCredentialRequest,
    security?: VerifyGcpIamCredentialSecurity | undefined,
    options?: RequestOptions,
  ): Promise<VerifyCredentialResult> {
    return unwrapAsync(externalCredentialsVerifyGcpIam(
      this,
      request,
      security,
      options,
    ));
  }
}
